import React from "react";
import { FormattedMessage } from "react-intl";

import { Container, Label, ChildrenContainer } from "./styled";

interface IProps {
  labelId?: string;
  children: any;
  containerMixin?: string;
  childrenMixin?: any;
  id?: string;
}

const FormItem: React.FC<IProps> = ({ labelId, children, containerMixin, childrenMixin, id }) => {
  return (
    <Container id={id} containerMixin={containerMixin}>
      {labelId && (
        <Label>
          <FormattedMessage id={labelId} />
        </Label>
      )}
      <ChildrenContainer containerMixin={childrenMixin}>{children}</ChildrenContainer>
    </Container>
  );
};

export default FormItem;
